import Moment from 'moment';

const money = (currency, cents) => `${currency} ${(cents / 100).toFixed(2)}`;

const contact = (name, phone) => [name, phone].filter(Boolean).join("  ·  ");

export const formatStopDateTime = (value) => {
  if (!value) return "";
  const m = Moment(new Date(value));
  return m.isValid() ? m.format("D MMM YYYY, h:mm A") : "";
};

export const buildPickUpSummary = (form) => {
  const location = form.pickUpLocation || {};
  const rows = [];

  if (location.address) rows.push({ label: "Address", value: location.address });
  if (form.pickUpPersonName || form.pickUpContactNumber) rows.push({ label: "Sender", value: contact(form.pickUpPersonName, form.pickUpContactNumber) });
  if (location.unitNumber) rows.push({ label: "Unit", value: location.unitNumber });

  const at = formatStopDateTime(form.pickUpDateTime);
  if (at) rows.push({ label: "Pick up", value: at });

  return rows;
};

export const buildDropOffSummary = (order, currency) => {
  const location = order.dropOffLocation || {};
  const rows = [];

  if (location.address) rows.push({ label: "Address", value: location.address });
  if (order.recipientName || order.recipientPhone) rows.push({ label: "Recipient", value: contact(order.recipientName, order.recipientPhone) });
  if (location.unitNumber) rows.push({ label: "Unit", value: location.unitNumber });

  const by = formatStopDateTime(order.deliverDateTime);
  if (by) rows.push({ label: "Deliver by", value: by });

  if (order.doorToDoor) rows.push({ label: "Door-to-door", value: order.doorToDoorFee > 0 ? money(currency, order.doorToDoorFee) : "Yes" });
  if (order.isCodEnabled) rows.push({ label: "COD", value: money(currency, order.codAmount || 0) });
  if (order.deliveryFee > 0) rows.push({ label: "Delivery fee", value: money(currency, order.deliveryFee) });

  return rows;
};
